import loadScript from '../common/loadScript.js'

export default async function loadPlaid() {
  if (!window.Plaid) {
    await loadScript('https://cdn.plaid.com/link/v2/stable/link-initialize.js')
  }

  return window.Plaid
}
